const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const moment = require("moment");
const _ = require("lodash");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const URLMake = require("../../../shared/URLMake");
const Avatar = require("../../core/view/Avatar");
const CopyTable = require("../../office/data/CopyTable");

// should use the same styles defined for a SubscriptionRow
const styles = require("./styles/SubscriptionRow.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};

/**
 * This component is similar to SubscriptionRow.jsx, with some of the
 * functionality removed. This component handles the rows for students who are
 * linked to a parent account (through platform), but do not have a BAO
 * subscription or parent relation on BA. This can include students who have the
 * both of the following:
 *
 * - have never had a family BAO subscription
 * - have a parent (ward) on platform because the parent bought them a product
 *   on VC, acad
 */
module.exports = augment(
	createReactClass({
		displayName: "AccountNonSubscriptionStudentRow",

		propTypes: {
			students: PT.array, //all students
			className: PT.string,
			data: PT.object.isRequired, //individual student data
			startPasswordChange: PT.bool, //If password change should start immediately after mount
			ownerCanPay: PT.bool,
			ownerCanReactivate: PT.bool,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		vaultEvents: {
			// Change student settings
			parentStudentInfoPending: function() {
				this.setState({studentInfoStatus: "pending"});
			},
			parentStudentInfoSuccess: function() {
				this.setState({studentInfoStatus: ""});
				this.closeModals();
			},
			parentStudentInfoFail: function(error) {
				this.setState({studentInfoStatus: error});
			},
			parentSubscriptionInfoPending: function() {
				// Do nothing
			},
			parentSubscriptionInfoSuccess: function() {
				// Do nothing
			},
			parentSubscriptionInfoFail: function(error, moreInfo, data) {
				const studentKey = _.get(data, "0.0.1");
				const key = _.findIndex(
					this.props.students,
					s => s.userID === this.props.data.userID
				);
				if (studentKey === key) {
					this.setState({error});
				}
			},
		},

		getInitialState: function() {
			if (this.props.startPasswordChange) {
				const {userID, displayName} = this.props.data;
				this.dispatchChangePassword(displayName, userID);
			}
			return {
				selectType: null, // select modal open if not null
				error: null,
				studentInfoStatus: null,
				cancelStatus: null,
			};
		},

		updateDisplayName: function(name) {
			this.props.dispatch({
				type: AT.SAVE_PARENT_STUDENT_INFO_REQUEST,
				studentID: this.props.data.userID,
				displayName: name,
			});
		},

		// initiate a checkout-like flow for the parent to purchase a subscription
		goToSubscribeFlow: function(type) {
			this.props.dispatch({
				type: AT.SET_PAGE,
				pageState: URLMake.state.forAccountSubscribe(
					type,
					this.props.data.userID
				),
				addToHistory: true,
			});
		},

		// a button to activate a student's subscription
		getButton: function() {
			let button = null;
			if (!this.props.data.inActiveClasses) {
				// We want to not show this button if the student is in a
				// class. Don't allow parent to activate subscription. This is
				// different from ownerCanReactivate check which uses
				// OpsParentAcc.canActivateStudent which only checks for max
				// subscriptions and warns parent.
				const className = styles.button;
				button = (
					<div
						className={className}
						onClick={this.withOwnerCanPayCheck(() =>
							this.goToSubscribeFlow("add")
						)}
					>
						Activate
					</div>
				);
			}
			return button;
		},

		closeModals: function(extraInfo) {
			this.setState(
				_.extend(
					{
						selectType: null,
						studentInfoStatus: null,
					},
					extraInfo
				)
			);
		},

		dispatchChangePassword: function(displayName, studentID) {
			this.props.dispatch({
				type: AT.START_CHANGE_PASSWORD,
				opts: {
					displayName,
					studentID,
					forAccountPage: true,
				},
			});
		},

		changePassword: function(displayName, studentID) {
			this.dispatchChangePassword(displayName, studentID);
			this.reset();
		},

		// Wraps a function with a check that the owner can pay &
		// shows a message if they cannot
		withOwnerCanPayCheck: function(f) {
			return (...args) => {
				if (!this.props.ownerCanPay) {
					this.props.dispatch({
						type: AT.SHOW_OFFICE_MESSAGE,
						messageType: "noOwnerPayment",
					});
				} else {
					f(...args);
				}
			};
		},

		reset: function() {
			this.setState({error: null});
		},

		// get details for the student's access to BAO. If they are given access
		// through enrollment in an Academy course, that information is checked here.
		getBAOAccessDetails: function() {
			const subDetails = (
				<div className={styles.subDetails}>
					<div className={styles.subItem}>
						<div className={styles.subLabelLarge}>
							{this.props.data.inActiveClasses
								? "Included in Class Enrollment"
								: "Inactive"}
						</div>
					</div>
					{this.getExpirationEl()}
					<div className={styles.spacer} />
					{this.getButton()}
				</div>
			);
			return subDetails;
		},

		getExpirationEl: function() {
			const {latestAcademyClassEndTime} = this.props.data;
			const EXPIRATION_WARNING_DAYS = 30;
			if (latestAcademyClassEndTime) {
				const expireText = `Access will end on ${moment(
					latestAcademyClassEndTime
				).format("ll")}`;
				// make the text red if the subscription is expiring soon
				const daysBefore = moment.duration(EXPIRATION_WARNING_DAYS, "d");
				const makeRed = moment().isAfter(
					moment(latestAcademyClassEndTime).subtract(daysBefore)
				);
				return (
					// make spacing consistent with SubscriptionRow.jsx
					<div className={styles.renew}>
						<div className={makeRed ? styles.warningText : styles.text}>
							{expireText}
						</div>
					</div>
				);
			}
			return null;
		},

		render: function() {
			const {className, data} = this.props;
			const {userID, displayName, avatar, username, inActiveClasses} = data;

			const basicInfo = (
				<div className={styles.userBasic}>
					<div className={styles.displayNameUneditable}>{displayName}</div>
					<div className={styles.username}>{username}</div>
				</div>
			);

			let errorMessage;
			if (this.state.error) {
				errorMessage = CopyTable.getTryAgain();
			}

			// controls opacity of the entire component, this should distinguish
			// whether or not the student has access to BAO
			const outerClass = inActiveClasses
				? styles.basicOuter
				: styles.inactiveOuter;

			return (
				<div className={className} key={userID}>
					<div className={styles.topRow}>
						<div className={outerClass}>
							<Avatar
								className={styles.avatar}
								avatar={avatar}
								hasRing={true}
								fallbackDisplayName={displayName}
							/>
							{basicInfo}
						</div>
						{this.getBAOAccessDetails()}
					</div>
					<div className={styles.error}>{errorMessage}</div>
				</div>
			);
		},
	})
);
